import React from 'react'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'outline' | 'cherry'
  size?: 'sm' | 'md' | 'lg'
  children: React.ReactNode
  disabled?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  type?: 'button' | 'submit' | 'reset'
  className?: string
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = 'primary',
      size = 'md',
      children,
      disabled = false,
      onClick,
      type = 'button',
      className = '',
      ...rest
    },
    ref
  ) => {
    const base =
      'rounded-warm font-body font-medium transition-all duration-200 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed focus-visible:ring-2 focus-visible:ring-green focus-visible:ring-offset-2'

    const variantClasses: Record<string, string> = {
      primary: 'bg-green text-parchment hover:bg-green-dark',
      cherry: 'bg-cherry text-parchment hover:bg-cherry-dark',
      secondary: 'bg-parchment-dark text-ink hover:bg-parchment',
      ghost: 'text-green hover:bg-green/5',
      outline: 'border-2 border-green text-green hover:bg-green hover:text-parchment',
    }

    const sizeClasses: Record<string, string> = {
      sm: 'px-4 py-2 text-sm',
      md: 'px-5 py-3 text-base',
      lg: 'px-6 py-4 text-lg',
    }

    const classes = [base, variantClasses[variant], sizeClasses[size], className]
      .filter(Boolean)
      .join(' ')

    return (
      <button
        ref={ref}
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={classes}
        {...rest}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'

export default Button
